function createCSRTollbarClass() {
    return class CSRTollbar extends Widget {
    constructor(element) {
        super(element);

        this.copy_link = this.element.querySelector('.tool-item.copy-link');
        this.send_link = this.element.querySelector('.tool-item.send-link');
        this.send_report = this.element.querySelector('.tool-item.send-report');

        // SMS routing is resolved by the backend/database.
        // Change only this base URL when promoting to ACCEPT/PROD.
        this.sms_api_base = 'https://f0cvwp74wj.execute-api.sa-east-1.amazonaws.com/dev';
        this.requires_employee_id = false;
        this.sms_route_loaded = false;
        this.sms_route_path = null;
        this.sms_route_loading_promise = null;
        this.sms_route_loading_path = null;

        const selected = QelpCareHUB.selected || {};
        const selectedDeviceName =
            selected.device && selected.device.name
                ? selected.device.name
                : (selected.os && selected.os.name ? selected.os.name : '');
        const selectedTopicName =
            selected.usecase && selected.usecase.topicName
                ? selected.usecase.topicName
                : '';

        this.send_link_modal = document.createElement('div');
        this.send_link_modal.innerHTML = `
        <div class="mdn-Modal-content mdn-Modal--sm send-link">
            <div class="mdn-Modal-header">
            <h1 class="mdn-Heading mdn-Heading--xs ">${QelpCareHUB.translations.send_report_modal.title}</h1>
            <button aria-label="Button close modal" class="mdn-Button mdn-Button--icon mdn-Button--secondary mdn-Button--md mdn-Button-header-close " title="close"> <em class="mdn-Icon-fechar mdn-Icon--sm "></em><span></span></button>
            </div>
            <div class="mdn-Modal-body">
            <p class="mdn-Text mdn-Text--body mdn-Text--sm mdn-Text--bold device-name">
                ${selectedDeviceName}
            </p>
            <p class="mdn-Text mdn-Text--body topic-name">
                ${selectedTopicName}
            </p>
            <p class="mdn-Text mdn-Text--body mdn-Text--md mdn-Text--bold success">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M29.3334 18.6667H26.6667V9.65056L16.0958 19.1173L5.33341 9.62125V25.3333H18.6667V28H4.00008C3.26371 28 2.66675 27.4031 2.66675 26.6667V5.33333C2.66675 4.59696 3.26371 4 4.00008 4H28.0001C28.7365 4 29.3334 4.59696 29.3334 5.33333V18.6667ZM6.01536 6.66667L16.0826 15.5493L26.0014 6.66667H6.01536ZM25.3334 29.3333L20.6194 24.6193L22.505 22.7337L25.3334 25.5621L30.0474 20.848L31.933 22.7337L25.3334 29.3333Z" fill="#13982B"/>
                </svg>
                ${QelpCareHUB.translations.send_report_modal.success}
            </p>

            <div class="mdn-Input" data-employee-id-container style="display: none;">
                <input
                    id="employeeId"
                    title="employeeId"
                    type="text"
                    maxlength="40"
                    class="mdn-Input-field "
                    value=""
                />
                <label for="employeeId" aria-required="true" class="mdn-Input-label">${QelpCareHUB.translations.send_report_modal.employeeIdLabel}</label>
                <small class="mdn-Input-errorFeedback">
                    <span class="mdn-Icon-circulo-exclamacao mdn-Icon--sm" aria-label="circulo-exclamacao"></span> Por favor, preencha este campo corretamente.
                </small>
            </div>

            <div class="mdn-Input">
                <input data-mdn-type="phone" data-mdn-mask="(99) 9999 9999|(99) 9 9999 9999" id="sendLink" title="phone" type="tel" class="mdn-Input-field " value="" />
                <label for="sendLink" aria-required="true" class="mdn-Input-label">${QelpCareHUB.translations.send_report_modal.label}</label>
                <small class="mdn-Input-errorFeedback">
                    <span class="mdn-Icon-circulo-exclamacao mdn-Icon--sm" aria-label="circulo-exclamacao"></span> Por favor, preencha este campo corretamente.
                </small>
            </div>
            </div>
            <div class="mdn-Modal-footer">
            <div class="mdn-Modal-footer-start"></div>
            <div class="mdn-Modal-footer-end">
            <button class="mdn-Button mdn-Button--primary mdn-Button--md  ">${QelpCareHUB.translations.send_report_modal.send}</button>
            </div>
            </div>
        </div>
        `;

        this.send_link_modal.classList.add('mdn-Modal');
        this.send_link_modal_close = this.send_link_modal.querySelector('.mdn-Button-header-close');
        this.send_link_modal_primary = this.send_link_modal.querySelector('.mdn-Modal-footer .mdn-Button--primary');
        this.send_link_modal_employee_id = this.send_link_modal.querySelector('#employeeId');
        this.send_link_modal_employee_id_container =
            this.send_link_modal.querySelector('[data-employee-id-container]');
        this.send_link_modal_telephone = this.send_link_modal.querySelector('.mdn-Input #sendLink');

        try {
            this.textarea = document.createElement('textarea');
            this.textarea.style.position = 'absolute';
            this.textarea.style.top = '0px';
            this.textarea.style.left = '0px';
            this.textarea.style.width = '0px';
            this.textarea.style.height = '0px';
            this.textarea.value = QelpCareHUB.live + QelpCareHUB.uri;
        } catch (error) {
            console.warn('Unable to initialize CSR toolbar textarea:', error);
            return;
        }

        if (this.copy_link) {
            this.copy_link.addEventListener('click', () => {
                this.copyCurrentUrl();

                this.copy_link.classList.add('copied');

                setTimeout(() => {
                    this.copy_link.classList.remove('copied');
                }, 2000);
            });
        } else {
            console.warn('CSR toolbar: copy-link element was not found.');
        }

        if (this.send_link_modal_employee_id) {
            this.send_link_modal_employee_id.addEventListener('keyup', e => {
                if (this.isEnterKey(e)) {
                    this.sendSMS();
                }
            });
        }

        if (this.send_link_modal_telephone) {
            this.send_link_modal_telephone.addEventListener('keyup', e => {
                if (this.isEnterKey(e)) {
                    this.sendSMS();
                }
            });
        }

        if (this.send_link_modal_primary) {
            this.send_link_modal_primary.addEventListener('click', () => {
                this.sendSMS();
            });
        }

        if (this.send_link_modal_close) {
            this.send_link_modal_close.addEventListener('click', () => {
                this.closeModal();
            });
        }

        if (this.send_link) {
            this.send_link.addEventListener('click', async () => {
                if (this.send_link.getAttribute('aria-busy') === 'true') {
                    return;
                }

                this.send_link.setAttribute('aria-busy', 'true');

                try {
                    const routeReady = await this.loadSmsRoute();

                    if (!routeReady) {
                        window.alert('Não foi possível carregar a configuração de envio de SMS.');
                        return;
                    }

                    this.send_link_modal.classList.add('mdn-is-open');
                } finally {
                    this.send_link.removeAttribute('aria-busy');
                }
            });
        } else {
            console.warn('CSR toolbar: send-link element was not found.');
        }

        document.body.appendChild(this.textarea);
        document.body.appendChild(this.send_link_modal);
    }

    isEnterKey(event) {
        // event.key is standard in current Chrome/Edge/Firefox. keyCode/which
        // are kept as fallbacks for older enterprise browser builds.
        return Boolean(
            event &&
            (
                event.key === 'Enter' ||
                event.keyCode === 13 ||
                event.which === 13
            )
        );
    }

    copyCurrentUrl() {
        const fallbackCopy = () => {
            try {
                this.textarea.focus();
                this.textarea.select();

                const copied = document.execCommand('copy');

                if (copied) {
                    console.log('URL copied with execCommand fallback');
                } else {
                    console.warn('Browser did not confirm URL copy.');
                }
            } catch (error) {
                console.warn('Unable to copy URL with execCommand:', error);
            }
        };

        const clipboardAvailable =
            typeof navigator !== 'undefined' &&
            navigator.clipboard &&
            typeof navigator.clipboard.writeText === 'function' &&
            (
                typeof window.isSecureContext === 'undefined' ||
                window.isSecureContext
            );

        if (!clipboardAvailable) {
            fallbackCopy();
            return;
        }

        navigator.clipboard.writeText(this.textarea.value)
            .then(() => {
                console.log('URL copied with Clipboard API', this.textarea.value);
            })
            .catch(error => {
                // Firefox/Chrome/Edge can reject Clipboard API because of
                // permissions or secure-context policy. Fall back instead of
                // leaving the copy action broken.
                console.warn('Clipboard API failed; using fallback:', error);
                fallbackCopy();
            });
    }

    async loadSmsRoute() {
        const currentPath = window.location.pathname;

        if (
            this.sms_route_loaded &&
            this.sms_route_path === currentPath
        ) {
            return true;
        }

        // Avoid duplicate API calls when the user clicks more than once while
        // a slow computer/network is still loading the same SMS route.
        if (
            this.sms_route_loading_promise &&
            this.sms_route_loading_path === currentPath
        ) {
            return this.sms_route_loading_promise;
        }

        this.sms_route_loading_path = currentPath;

        const loadingPromise = this.fetchSmsRoute(currentPath);
        this.sms_route_loading_promise = loadingPromise;

        try {
            return await loadingPromise;
        } finally {
            // Do not clear a newer request if the page/path changed while this
            // request was still in progress.
            if (this.sms_route_loading_promise === loadingPromise) {
                this.sms_route_loading_promise = null;
                this.sms_route_loading_path = null;
            }
        }
    }

    async fetchSmsRoute(currentPath) {
        const maxAttempts = 3;

        if (typeof window.fetch !== 'function') {
            console.error('CSR toolbar: Fetch API is not available in this browser.');
            this.sms_route_loaded = false;
            this.sms_route_path = null;
            return false;
        }

        for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
            try {
                const url =
                    `${this.sms_api_base}/api-csr/route?path=${encodeURIComponent(currentPath)}`;

                console.log(`Loading SMS route (attempt ${attempt}/${maxAttempts}):`, currentPath);

                // Intentionally no client-side timeout here. Some workstations
                // and pages are slow, so the browser is allowed to wait for the
                // API response instead of failing because of an arbitrary timer.
                const httpResponse = await window.fetch(url, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                });

                if (!httpResponse.ok) {
                    const error = new Error(`SMS route HTTP ${httpResponse.status}`);

                    // 4xx normally means a real request/configuration problem.
                    // 429 and 5xx may be transient and are safe to retry.
                    error.retryable =
                        httpResponse.status === 429 ||
                        httpResponse.status >= 500;

                    throw error;
                }

                const response = await httpResponse.json();

                if (
                    response.error ||
                    !response.data ||
                    typeof response.data.requiresEmployeeId !== 'boolean'
                ) {
                    const error = new Error('Invalid SMS route response');
                    error.retryable = true;
                    throw error;
                }

                this.requires_employee_id =
                    response.data.requiresEmployeeId;

                if (this.send_link_modal_employee_id_container) {
                    this.send_link_modal_employee_id_container.style.display =
                        this.requires_employee_id ? '' : 'none';
                }

                if (
                    !this.requires_employee_id &&
                    this.send_link_modal_employee_id
                ) {
                    this.send_link_modal_employee_id.value = '';
                }

                this.sms_route_loaded = true;
                this.sms_route_path = currentPath;

                console.log('SMS route loaded:', {
                    path: currentPath,
                    requiresEmployeeId: this.requires_employee_id
                });

                return true;
            } catch (error) {
                const retryable = error.retryable !== false;
                const isLastAttempt = attempt === maxAttempts;

                console.error(
                    `Unable to load SMS route (attempt ${attempt}/${maxAttempts}):`,
                    error
                );

                if (!retryable || isLastAttempt) {
                    this.sms_route_loaded = false;
                    this.sms_route_path = null;
                    return false;
                }

                // Small progressive delay before retrying transient failures.
                // 750ms, then 1500ms.
                await this.sleep(attempt * 750);
            }
        }

        this.sms_route_loaded = false;
        this.sms_route_path = null;
        return false;
    }

    sleep(milliseconds) {
        return new Promise(resolve => {
            setTimeout(resolve, milliseconds);
        });
    }

    async sendSMS() {
        // The page/path may have changed after the modal was created. Always
        // confirm the route before sending so employeeId rules stay correct.
        if (
            !this.sms_route_loaded ||
            this.sms_route_path !== window.location.pathname
        ) {
            const routeReady = await this.loadSmsRoute();

            if (!routeReady) {
                window.alert('Não foi possível carregar a configuração de envio de SMS.');
                return;
            }
        }

        if (!this.send_link_modal_telephone || !this.send_link_modal_primary) {
            console.error('SMS modal is not completely initialized.');
            window.alert('Não foi possível inicializar a tela de envio de SMS.');
            return;
        }

        this.send_link_modal.classList.remove('warning', 'success');
        this.send_link_modal.classList.add('sending');

        const employeeId = this.send_link_modal_employee_id
            ? this.send_link_modal_employee_id.value.trim()
            : '';

        const telephone = this.send_link_modal_telephone.value.replace(/[^0-9]/g, '');

        const url = `${this.sms_api_base}/api-csr/send/sms`;

        if (
            telephone.length < 10 ||
            telephone.length > 11 ||
            (
                this.requires_employee_id &&
                (!employeeId || employeeId.length > 40)
            )
        ) {
            this.send_link_modal.classList.remove('sending');
            this.send_link_modal.classList.add('warning');
            return;
        }

        if (this.send_link_modal_employee_id) {
            this.send_link_modal_employee_id.setAttribute('disabled', 'disabled');
        }

        this.send_link_modal_telephone.setAttribute('disabled', 'disabled');
        this.send_link_modal_primary.setAttribute('disabled', 'disabled');

        // Browser sends only the relative pathname. No domain/query string.
        const data = {
            to: telephone,
            path: window.location.pathname
        };

        if (this.requires_employee_id) {
            data.employeeId = employeeId;
        }

        try {
            console.log('Sending SMS request:', {
                path: data.path,
                requiresEmployeeId: this.requires_employee_id
            });

            const httpResponse = await window.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            const responseText = await httpResponse.text();
            let response = {};

            if (responseText) {
                try {
                    response = JSON.parse(responseText);
                } catch (parseError) {
                    console.error('Invalid JSON returned by SMS API');
                    throw new Error('A API de SMS retornou uma resposta inválida.');
                }
            }

            console.log('SMS API response:', httpResponse.status, {
                error: response.error,
                message: response.message
            });

            if (!httpResponse.ok) {
                throw new Error(
                    response.message ||
                    response.return ||
                    'Houve um erro ao enviar mensagem.'
                );
            }

            if (
                response.error === true ||
                response.error === 'true' ||
                response.success === false ||
                response.success === 2
            ) {
                throw new Error(
                    response.message ||
                    response.return ||
                    'Houve um erro ao enviar mensagem.'
                );
            }

            this.send_link_modal.classList.remove('sending', 'warning');
            this.send_link_modal.classList.add('success');

            setTimeout(() => {
                this.closeModal();
            }, 2000);
        } catch (error) {
            console.error('Erro ao enviar SMS:', error);

            this.send_link_modal.classList.remove('sending', 'success');
            this.send_link_modal.classList.add('warning');

            window.alert(
                error.message ||
                'Houve um erro ao enviar mensagem.'
            );

            if (this.send_link_modal_employee_id) {
                this.send_link_modal_employee_id.removeAttribute('disabled');
            }

            this.send_link_modal_telephone.removeAttribute('disabled');
            this.send_link_modal_primary.removeAttribute('disabled');
        }
    }

    closeModal() {
        this.send_link_modal.classList.remove('mdn-is-open', 'success', 'sending', 'warning');

        if (this.send_link_modal_employee_id) {
            this.send_link_modal_employee_id.removeAttribute('disabled');
        }

        if (this.send_link_modal_telephone) {
            this.send_link_modal_telephone.removeAttribute('disabled');
        }

        if (this.send_link_modal_primary) {
            this.send_link_modal_primary.removeAttribute('disabled');
        }
    }
    };
}


// Browser compatibility notes:
// - Current Chrome and Chromium Edge: standards path.
// - Current Firefox: standards path, with clipboard permission fallback.
// - Babel should still compile this source using the project's existing config.
// - No optional chaining or Element.append dependency is required by this file.

// Some workstations can take considerably longer to render the page. Do not
// assume that eHelpFrameworkReady means every toolbar element and QelpCareHUB
// dependency is already available at that exact millisecond.
let csrToolbarInitialized = false;
let csrToolbarInitTimer = null;
let csrToolbarInitAttempts = 0;
let CSRTollbarClass = null;

const CSR_TOOLBAR_INIT_RETRY_MS = 500;
const CSR_TOOLBAR_INIT_MAX_ATTEMPTS = 1200; // Up to 10 minutes on very slow workstations.

function isCSRToolbarReady() {
    const frameworkReady =
        typeof Widget !== 'undefined' &&
        typeof eHelpFramework !== 'undefined' &&
        eHelpFramework.widgets &&
        typeof eHelpFramework.widgets.push === 'function';

    const hubReady =
        typeof QelpCareHUB !== 'undefined' &&
        QelpCareHUB.translations &&
        QelpCareHUB.translations.send_report_modal &&
        QelpCareHUB.selected;

    const toolbar = document.querySelector('.csr-toolbar');
    const sendLink = toolbar
        ? toolbar.querySelector('.tool-item.send-link')
        : null;

    return Boolean(
        frameworkReady &&
        hubReady &&
        document.body &&
        toolbar &&
        sendLink
    );
}

function scheduleCSRToolbarInit() {
    if (csrToolbarInitialized || csrToolbarInitTimer) {
        return;
    }

    if (csrToolbarInitAttempts >= CSR_TOOLBAR_INIT_MAX_ATTEMPTS) {
        console.error(
            'CSR toolbar was not initialized because the page did not become ready within 10 minutes.'
        );
        return;
    }

    csrToolbarInitTimer = setTimeout(() => {
        csrToolbarInitTimer = null;
        initializeCSRToolbar();
    }, CSR_TOOLBAR_INIT_RETRY_MS);
}

function initializeCSRToolbar() {
    if (csrToolbarInitialized) {
        return;
    }

    csrToolbarInitAttempts += 1;

    if (!isCSRToolbarReady()) {
        if (
            csrToolbarInitAttempts === 1 ||
            csrToolbarInitAttempts % 60 === 0
        ) {
            console.log(
                `Waiting for CSR toolbar dependencies (${csrToolbarInitAttempts}/${CSR_TOOLBAR_INIT_MAX_ATTEMPTS})...`
            );
        }

        scheduleCSRToolbarInit();
        return;
    }

    try {
        if (!CSRTollbarClass) {
            CSRTollbarClass = createCSRTollbarClass();
        }

        eHelpFramework.widgets.push(new CSRTollbarClass('.csr-toolbar'));
        csrToolbarInitialized = true;

        if (csrToolbarInitTimer) {
            clearTimeout(csrToolbarInitTimer);
            csrToolbarInitTimer = null;
        }

        console.log(
            `CSR toolbar initialized after ${csrToolbarInitAttempts} attempt(s).`
        );
    } catch (error) {
        console.error('Unable to initialize CSR toolbar:', error);
        scheduleCSRToolbarInit();
    }
}

window.addEventListener('eHelpFrameworkReady', () => {
    initializeCSRToolbar();
});

// Also try immediately. This covers the opposite race condition where this
// script is loaded after eHelpFrameworkReady has already fired.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initializeCSRToolbar();
    });
} else {
    initializeCSRToolbar();
}
